import * as React from 'react';
import styled, { css } from 'styled-components';
import { faHeart as farHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEqual from 'react-fast-compare';
import { isItemSaved } from '@/redux/modules/saveItem';
import { isUserLoggedIn } from '@/redux/modules/user';
import { useSelector } from 'react-redux';

type Props = {
    className?: string;
    itemId: number;
};

const ItemSaveIcon = ({ className = '', itemId }: Props) => {
    const saved = useSelector((state) => isItemSaved(state, itemId), isEqual);
    const userLoggedIn = useSelector((state) => isUserLoggedIn(state), isEqual);
    const icon = saved && userLoggedIn ? fasHeart : farHeart;

    return (
        <SaveContainerDiv className={className}>
            <StyledFontAwesomeIcon $backgroundIcon icon={fasHeart} />
            <StyledFontAwesomeIcon $backgroundIcon={false} icon={icon} />
        </SaveContainerDiv>
    );
};

export default React.memo<Props>(ItemSaveIcon, isEqual);

const SaveContainerDiv = styled.div`
    width: 20px;
    height: 20px;
    position: relative;
`;

const BackgroundIcon = css`
    color: ${({ theme }) => theme.colors.grey500};
    opacity: 0.85;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)<{ $backgroundIcon: Boolean }>`
    cursor: pointer;
    transition: all 0.2s ease-in;
    color: ${({ theme }) => theme.colors.red100};
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    font-size: 20px;
    ${({ $backgroundIcon }) => $backgroundIcon && BackgroundIcon}

    &:hover {
        transform: scale(1.1);
    }
`;
